import { useState, useRef } from 'react';
import XTable from 'components/XTable';
import { Modal, Input, notification, Space, Button, Row, Col, Divider } from 'antd';
import { getRoleListApi, postAddRoleApi } from 'api/authV1';
import { getRoleMenuApi, putRoleMenuApi, delRoleMenuApi, getMenuListApi } from 'api/menu';
import XForm from 'components/XForm';
const RoleMGT = () => {
    const xTableRef = useRef();
    const xFormRef = useRef();
    const xRoleMenusTableRef = useRef();
    const xMenusTableRef = useRef();
    const [addRoleVisible, setaddRoleVisible] = useState(false);
    const [addLoading, setaddLoading] = useState(false);
    const [roleMenuVisible, setroleMenuVisible] = useState(false);
    const [rolename, setrolename] = useState(false);
    const [id, setid] = useState('');
    const [roleMenus, setRoleMenus] = useState([]);

    const addRole = () => {
        setaddRoleVisible(true);
    };

    // 确认新增
    const addRoleOk = () => {
        xFormRef.current.form?.submit();
    };

    // 执行新增角色
    const onFinish = values => {
        setaddLoading(true);
        postAddRoleApi(values).then(res => {
            if (res.success) {
                notification.success({
                    message: '角色新增成功。',
                });
                setaddRoleVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setaddLoading(false);
        });
    };

    const showMenuModal = data => {
        const { id, name } = data;
        getRoleMenus(id);
        setid(id);
        setrolename(name);
        setroleMenuVisible(true);
    };

    const roleMenusModalCancel = () => {
        setid('');
        setrolename('');
        setroleMenuVisible(false);
    };

    // 获取所有已设置菜单
    const getRoleMenus = id => {
        const params = {
            pageSize: 999,
            role_id: id,
        };
        getRoleMenuApi(params).then(res => {
            if (res.success) {
                const roleIds = (res.list || []).map(item => item.id);
                setRoleMenus(roleIds);
            }
        });
    };

    // 添加|移除角色菜单
    const addOrDelRoleMenu = (menuId, type) => {
        const params = type === 'add' ? { menuId, roleId: id } : { menu_id: menuId, role_id: id };
        const api = type === 'add' ? putRoleMenuApi : delRoleMenuApi;
        const tipText = type === 'add' ? '添加' : '移除';
        const isDel = type === 'del';
        api(params).then(res => {
            if (res.success) {
                notification.success({
                    message: `菜单${tipText}成功`,
                });
                getRoleMenus(id);
                xRoleMenusTableRef.current.refreshTable &&
                    xRoleMenusTableRef.current.refreshTable(isDel);
                xMenusTableRef.current.refreshTable && xMenusTableRef.current.refreshTable();
            }
        });
    };

    const columns = [
        {
            title: '角色id',
            dataIndex: 'id',
        },
        {
            title: '角色名称',
            dataIndex: 'name',
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, data) => {
                return (
                    <Space size="middle">
                        <span className="actionText" onClick={() => showMenuModal(data)}>
                            设置角色菜单
                        </span>
                    </Space>
                );
            },
        },
    ];
    const actionBtns = [{ text: '新增角色', onClick: addRole }];
    const formItems = [
        {
            formItemApis: {
                label: '角色名称',
                name: 'roleName',
                rules: [{ required: true }],
            },
            item: <Input />,
        },
    ];
    return (
        <div>
            <XTable
                columns={columns}
                api={getRoleListApi}
                rowKey="id"
                actionBtns={actionBtns}
                ref={xTableRef}
            />
            {addRoleVisible ? (
                <Modal
                    title="新增角色"
                    visible={addRoleVisible}
                    centered
                    onOk={addRoleOk}
                    okButtonProps={{ loading: addLoading }}
                    onCancel={() => setaddRoleVisible(false)}>
                    <XForm
                        formApis={{
                            name: 'addRole',
                            onFinish: onFinish,
                        }}
                        formItems={formItems}
                        ref={xFormRef}
                    />
                </Modal>
            ) : null}
            {id && roleMenuVisible ? (
                <Modal
                    title="设置菜单"
                    width={1000}
                    centered
                    visible={roleMenuVisible}
                    footer={[
                        <Button type="primary" onClick={roleMenusModalCancel}>
                            关闭
                        </Button>,
                    ]}
                    onCancel={roleMenusModalCancel}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Divider orientation="left" style={{ margin: ' 0 0 16px' }}>
                                {rolename}已设置菜单
                            </Divider>
                            <XTable
                                size="small"
                                columns={[
                                    { title: '菜单名称', dataIndex: 'name' },
                                    { title: '菜单编码', dataIndex: 'code' },
                                    {
                                        title: '操作',
                                        dataIndex: '',
                                        render: (val, data) => {
                                            return (
                                                <span
                                                    className="actionText"
                                                    onClick={() =>
                                                        addOrDelRoleMenu(data.id, 'del')
                                                    }>
                                                    移除
                                                </span>
                                            );
                                        },
                                    },
                                ]}
                                api={getRoleMenuApi}
                                apiParams={{ role_id: id }}
                                scrollY={'calc(100vh - 340px)'}
                                rowKey="id"
                                ref={xRoleMenusTableRef}
                            />
                        </Col>
                        <Col span={12}>
                            <Divider orientation="left" style={{ margin: ' 0 0 16px' }}>
                                所有菜单
                            </Divider>
                            <XTable
                                size="small"
                                columns={[
                                    { title: '菜单名称', dataIndex: 'name' },
                                    { title: '菜单编码', dataIndex: 'code' },
                                    {
                                        title: '操作',
                                        dataIndex: '',
                                        render: (val, data) => {
                                            const hasId = (roleMenus || []).includes(data.id);
                                            return (
                                                <span
                                                    className="actionText"
                                                    onClick={() =>
                                                        addOrDelRoleMenu(
                                                            data.id,
                                                            hasId ? 'del' : 'add',
                                                        )
                                                    }>
                                                    {hasId ? '移除' : '添加'}
                                                </span>
                                            );
                                        },
                                    },
                                ]}
                                api={getMenuListApi}
                                scrollY={'calc(100vh - 340px)'}
                                rowKey="id"
                                ref={xMenusTableRef}
                            />
                        </Col>
                    </Row>
                </Modal>
            ) : null}
        </div>
    );
};
export default RoleMGT;
